import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import {
  BehaviorSubject,
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  map,
  Observable,
  of,
  startWith,
  Subject,
  takeUntil,
} from 'rxjs';
import { ApiResponse } from 'src/app/models/interface/CAM/baseResponseInterfaces';
import { Branch } from 'src/app/models/interface/CAM/CompanyProfileInterface';
import { NewTraveler } from 'src/app/models/interface/CAM/traveler-management';
import {
  Department,
  Designation,
} from 'src/app/models/interface/CAM/TravellerInterface';
import { AccountService } from 'src/app/services/accountService/account.service';
import { ApiService } from 'src/app/services/apiService/api.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { ContentService } from '../../services/content.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { SignUpContentServiceService } from 'src/app/modules/registration/services/sign-up-content-service.service';
import { jwtDecode } from 'jwt-decode';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { environment } from 'src/environments/environment';
import { DataLayerService } from 'src/app/services/dataLayer/datalayer.service';
import { NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective } from '@ng-select/ng-select';
import { AutoBlurSelectDirective } from '../../../../shared/directive/auto-select-blur.directive';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { DateOfBirthCalendarComponent } from '../../../registration/components/date-of-birth-calendar/date-of-birth-calendar.component';
import { ExpiryDateComponent } from '../expiry-date/expiry-date.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';

export interface StateGroup {
  letter: string;
  names: {
    name: string;
    code: string;
    isdCode: string;
    countryFlag: string;
  }[];
}

@Component({
    selector: 'app-new-traveler-form',
    templateUrl: './new-traveler-form.component.html',
    styleUrls: ['./new-traveler-form.component.scss'],
    imports: [ReactiveFormsModule, FormsModule, NgSelectComponent, AutoBlurSelectDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgIf, NgLabelTemplateDirective, NgNotFoundTemplateDirective, MatError, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, DateOfBirthCalendarComponent, ExpiryDateComponent, MatSelect, NgFor, MatOption, MatRadioGroup, MatRadioButton, MatProgressSpinner, MatButton, DatePipe]
})
export class NewTravelerFormComponent implements OnInit, OnDestroy {
  addNewTravelerForm!: FormGroup;
  newCustomCountries: any[] = [];
  countriesLists: any[] = [];
  filteredCountries: any;
  stateGroupOptions: Observable<StateGroup[]> = new BehaviorSubject<
    StateGroup[]
  >([]).asObservable();
  NationalityOptions: Observable<StateGroup[]> = new BehaviorSubject<
    StateGroup[]
  >([]).asObservable();
  PreviousCountryCode: any;
  elmVerified: boolean = false;
  selectedExpiryDate: Date | null = null;
  branchList: Branch[] = [];
  departmentLIst: any[] = [];
  designationList: any[] = [];
  public _siteCoreBaseUrl = environment.siteCoreBaseUrl;
  CommonObj = {
    docType: '',
    docName: '',
  };

  get docExpiryMaxYears(): number {
    if (this.CommonObj?.docType === 'iqama') {
      return 1;
    }
    return 10;
  }

  isChildVisible: { [key: string]: boolean } = {
    isDOBCalendarVisible: false,
    isExpiaryCalendarVisible: false,
    // Add other child components here
  };
  private readonly destroy$ = new Subject<void>();
  content: any;
  onBoardContent: any;
  titles: any[] = [];
  isEmpCodeAcceptable = false;
  isEmpCodeCheckLoading = false;
  isInviteLoading = false;

  constructor(
    private readonly fb: FormBuilder,
    public _CommonService: CommonService,
    public _ApiService: ApiService,
    private readonly _AccountService: AccountService,
    private readonly _camService: CamService,
    private readonly _ToastrApiService: ToastrApiService,
    private readonly _Router: Router,
    private readonly contentService: ContentService,
    private readonly dictionaryContentService: DisctionaryContent,
    private readonly signUpContentService: SignUpContentServiceService,
    private travelerManagement: TravelerManagement,
    private readonly _CamService: CamService,
    private _DataLayerService: DataLayerService
  ) {
    this.addNewTravelerForm = this.fb.group({
      Nationality: [null],
      residence: [null],
      identityNumber: [
        null,
        [Validators.minLength(6), Validators.maxLength(10)],
      ],
      docExpiary: [null],
      dateOfBirth: [null],
      title: [null],
      firstname: [null, [Validators.minLength(2), Validators.maxLength(50)]],
      lastname: [null, [Validators.minLength(2), Validators.maxLength(50)]],
      gender: ['Male'],
      empCode: [
        '',
        [Validators.required, Validators.minLength(4), Validators.maxLength(15)],
      ],
      email: [
        '',
        [Validators.required, Validators.email, Validators.maxLength(200)],
      ],
      countryCode: [null],
      mobileNumber: [null,[Validators.minLength(8), Validators.maxLength(12)]],
      branch: ['', [Validators.required]],
      department: [null],
      designation: [null],
      userType: ['2', Validators.required],
    });
  }

  ngOnInit(): void {
    combineLatest({
      content: this.contentService.content$,
      dictionary: this.dictionaryContentService.content$,
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.content = {
          ...res.content,
          dictionary: res.dictionary,
        };
      });
    this.signUpContentService.content$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.onBoardContent = res;
        this.getSiteCoreArray('b2b.register.titledropdown')
      });
    this._ApiService
      .getCountriesData()
      .then(($res) => {
        this.newCustomCountries =
          this._CommonService.groupCountriesFilter($res);
        this.groupCountries($res);
      })
      .catch(($err) => { });

    this.addNewTravelerForm
      .get('Nationality')
      ?.valueChanges.pipe(
        startWith(''),
        map((value) => this.filterCountries(value)),
      )
      .subscribe((filteredCountries) => {
        this.filteredCountries = filteredCountries;
        this.groupCountries(this.filteredCountries);
      });

    this.addNewTravelerForm
      .get('Nationality')
      ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(() => {
        this.updateDocumentType(
          this.addNewTravelerForm.get('Nationality')?.value,
          this.addNewTravelerForm.get('residence')?.value,
        );
        this.verifyELM('nn');
      });

    this.addNewTravelerForm
      .get('residence')
      ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(() => {
        this.updateDocumentType(
          this.addNewTravelerForm.get('Nationality')?.value,
          this.addNewTravelerForm.get('residence')?.value,
        );
        this.verifyELM('nn');
      });

    this.getCorporateInformation();
    window.scrollTo({ top: 0, behavior: 'smooth' });


    // this.addNewTravelerForm.get('countryCode')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
    //   this.updatePhoneNumberValidators()
    // });

    const empCodeCtrl = this.addNewTravelerForm.get('empCode')!;

    empCodeCtrl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => { this.isEmpCodeAcceptable = false; });

    empCodeCtrl.valueChanges
      .pipe(debounceTime(500), takeUntil(this.destroy$))
      .subscribe((value) => {
        if (!empCodeCtrl.valid || !value?.trim() || !empCodeCtrl.dirty) return;
        this._checkEmployeeCodeDuplicate(value.trim());
      });
  }

  groupCountries(data: any): void {
    if (!this.countriesLists?.length) {
      this.countriesLists = data;
    }
    this.filteredCountries = data;
    const grouped: {
      [key: string]: {
        name: string;
        code: string;
        isdCode: string;
        countryFlag: string;
      }[];
    } = this.filteredCountries?.reduce(
      (acc: any, country: any) => {
        const firstLetter = country.countryName[0].toUpperCase(); // Use countryName instead of Country
        if (!acc[firstLetter]) {
          acc[firstLetter] = [];
        }
        acc[firstLetter].push({
          name: country.countryName,
          code: country.isoCode,
          isdCode: country.code,
          countryFlag: country.newFlag.src,
        });
        return acc;
      },
      {} as {
        [key: string]: {
          name: string;
          code: string;
          isdCode: string;
          countryFlag: string;
        }[];
      },
    );
    if (this.filteredCountries) {
      const sortedGroupLetters = Object.keys(grouped).sort((a, b) =>
        a.localeCompare(b),
      );

      const saudiGroup = grouped['S']?.find((c) => c.name === 'Saudi Arabia');

      if (saudiGroup) {
        grouped['S'] = grouped['S'].filter((c) => c.name !== 'Saudi Arabia');
        grouped['S'] = [
          {
            name: 'Saudi Arabia',
            code: 'SA',
            isdCode: '+966',
            countryFlag:
              '/-/media/SaudiaWebApp/data/media/img/Flags/Latest-flags/Flag-saudi_arabia.ashx?rev=856c905ee3344e1295e5948ae4d64d9a',
          },
          ...grouped['S'],
        ];

        const index = sortedGroupLetters.indexOf('S');
        if (index > -1) {
          sortedGroupLetters.splice(index, 1);
        }
        sortedGroupLetters.unshift('S');
      }

      // Wrap the result in `of()` to make it an Observable
      this.stateGroupOptions = of(
        sortedGroupLetters.map((letter) => {
          return {
            letter: letter,
            names: grouped[letter],
          };
        }),
      );
    }
  }

  filterCountries(value: any): void {
    const searchField =
      value?.stateGroup?.split('+')?.length === 1
        ? 'countryName'
        : 'code';
  
    const searchValue = (value?.stateGroup || '')
      .replace('+', '')
      .toLowerCase();
  
    const currentState: any[] = this.countriesLists.filter(
      ($country: any) =>
        $country[searchField]
          ?.toString()
          .toLowerCase()
          .includes(searchValue)
    );
  
    this.groupCountries(currentState);
  
    if (currentState.length < 2) {
      this.PreviousCountryCode = currentState;
    }
  }

  convertToISODate(dob: string): string {
    if (!dob) return '';

    // Split the date into day, month, and year
    const dateParts = dob.split('/');

    // If the format is correct, return the date in the desired format (YYYY-MM-DD)
    if (dateParts.length === 3) {
      const day = dateParts[0];
      const month = dateParts[1];
      const year = dateParts[2];

      // Ensure the month and day are zero-padded to 2 digits
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    return dob; // If the format is incorrect, return the original string
  }

  private buildELMPayload(): any | null {
    const dob = this.addNewTravelerForm.get('dateOfBirth')?.value;
    const identity = this.addNewTravelerForm.get('identityNumber')?.value;
    const nationality = this.addNewTravelerForm.get('Nationality')?.value;

    if (!dob || !identity) return null;

    const formattedDob = this.convertToISODate(dob);

    switch (this.CommonObj.docType) {
      case 'nationalID':
        return {
          nationalID: identity,
          nationality: nationality,
          dateOfBirth: formattedDob,
        };

      case 'iqama':
        return {
          iqama: identity,
          dateOfBirth: formattedDob,
        };

      default:
        return null; // passport → no ELM call
    }
  }

  getImageUrl(path: string): string {
    if (!path) return '';

    const base = this._siteCoreBaseUrl?.replace(/\/+$/, '') || '';
    const cleanPath = path.replace(/^\/+/, '');

    return `${base}/${cleanPath}`;
  }

  verifyELM(_: any): void {
    if (this.CommonObj.docType === 'passport' || this.CommonObj.docType == '') {
      this.addNewTravelerForm.get('firstname')?.enable();
      this.addNewTravelerForm.get('lastname')?.enable();
      return;
    }

    this.addNewTravelerForm.get('firstname')?.disable();
    this.addNewTravelerForm.get('lastname')?.disable();

    const payload = this.buildELMPayload();
    if (!payload) return;

    this._AccountService.VerifyELMV1(payload).subscribe(
      (response) => {
        if (response?.data?.firstName) {
          this.addNewTravelerForm.patchValue({
            firstname: response.data.firstName,
            lastname: response.data.lastName,
          });
        }
        this.elmVerified = true;
        this.addNewTravelerForm.get('identityNumber')?.setErrors(null);
      },
      (error) => {
        const ctrl = this.addNewTravelerForm.get('identityNumber');
        ctrl?.setErrors({
          ...(ctrl?.errors || {}),
          elmError: true,
        });
        this.addNewTravelerForm.patchValue({
          firstname: '',
          lastname: '',
        });

        ctrl?.markAsTouched();
      },
    );
  }

  updateDocumentType(nationality: string, residence: string): void {
    const identityNumberControl = this.addNewTravelerForm.get('identityNumber');

    if (!nationality || !residence) {
      this.CommonObj = { docType: '', docName: '' };
      identityNumberControl?.clearValidators();
      identityNumberControl?.setErrors(null);
      identityNumberControl?.updateValueAndValidity();
      return;
    }

    if (nationality === 'SA' && residence === 'SA') {
      this.CommonObj = {
        docType: 'nationalID',
        docName: 'National ID',
      };
      identityNumberControl?.setValidators([
        Validators.required,
        Validators.pattern(/^1\d{9}$/),
      ]);
    }

    if (nationality === 'SA' && residence !== 'SA') {
      this.CommonObj = {
        docType: 'nationalID',
        docName: 'National ID',
      };
      identityNumberControl?.setValidators([
        Validators.required,
        Validators.pattern(/^1\d{9}$/),
      ]);
    }
    
    if (nationality !== 'SA' && residence === 'SA') {
      this.CommonObj = {
        docType: 'iqama',
        docName: 'Iqama',
      };
      identityNumberControl?.setValidators([
        Validators.required,
        Validators.pattern(/^2\d{9}$/),
      ]);
    }

    if (nationality !== 'SA' && residence !== 'SA') {
      this.CommonObj = {
        docType: 'passport',
        docName: 'Passport',
      };
      identityNumberControl?.setValidators([
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9]{6,12}$/),
      ]);
    }

    identityNumberControl?.updateValueAndValidity();
  }

  showComponent(componentKey: string, controlName?: string) {
    this.isChildVisible[componentKey] = true;
    for (const key in this.isChildVisible) {
      if (key !== componentKey) {
        this.isChildVisible[key] = false;
      }
    }
    if (!!controlName) {
      // this.travelerSignupForm.get(controlName)?.removeValidators([Validators.required]);
      // this.travelerSignupForm.get(controlName)?.updateValueAndValidity();;
    }
  }

  onDateSelected2(
    event: { type: string; date: Date | null },
    key: string,
  ): void {
    if (event.type === 'dob') {
      if (
        !event.date ||
        event.date.toDateString() === new Date(0).toDateString()
      ) {
        return;
      }
      this.selectedExpiryDate = event.date ? new Date(event.date) : null;
      const formattedDate = this.getFormattedDate(this.selectedExpiryDate);
      this.addNewTravelerForm.get('docExpiary')?.setValue(formattedDate);
      this.isChildVisible[key] = false;
    }
  }
  getFormattedDate(date: Date | null): string | null {
    if (!date) return null;
    const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  onConfirm(componentKey: string) {
    this.verifyELM('nn');
    this.isChildVisible[componentKey] = false;
  }

  onDateSelected(event: any): void {
    if (event.isCalenderShow === true) {
      const date = event.date ? new Date(event.date) : null; // Ensure date is valid or null
      const dobDateControl = this.addNewTravelerForm.get('dateOfBirth');
      if (date) {
        // Format the date and set it in the form control
        const formattedDate = this.getFormattedDate(date);

        dobDateControl?.setValue(formattedDate); // Update the form control value
        dobDateControl?.clearValidators(); // Clear validators for a valid date
      } else {
        // Handle the case when the date is null
        dobDateControl?.setValue(null);
      }
      // Update form control validation status
      dobDateControl?.updateValueAndValidity();
      // Hide the DOB calendar
      this.isChildVisible['isDOBCalendarVisible'] = false;
    }
    this.verifyELM('nn');
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: Event) {
    const clickedElement = event?.target as HTMLElement;
    const isClickInside =
      clickedElement?.closest('.calendar-popup') ||
      clickedElement?.closest('.datepicker-content-container') ||
      clickedElement?.closest('mat-form-field');
    if (!isClickInside) {
      this.isChildVisible['isDOBCalendarVisible'] = false;
      this.isChildVisible['isExpiaryCalendarVisible'] = false;
    }
  }

  getCorporateInformation() {
    this._camService
      .getCorporateInformation()
      .then((res: any) => {
        if (res && res.status === 'Success' && res.data) {
          this.branchList = res.data.branches || [];
          this.departmentLIst = res.data.departments || [];
          this.designationList = res.data.designations || [];
          console.log('branchList', this.branchList);
          console.log('departmentLIst', this.departmentLIst);
        } else {
          this.branchList = [];
        }
      })
      .catch((err: any) => {
        const errMsg =
          'Something went wrong while fetching corporate information.';
        this._ToastrApiService.show('error', errMsg);
        console.error('Error fetching corporate information:', err);
        this.branchList = []; // Reset tableData on error
      });
  }

  onSubmit() {
    this.travelerManagement.traveler_add_success('Send invite');
    if (this.addNewTravelerForm.invalid) {
      return;
    }
    this.isInviteLoading = true;

    const payload: NewTraveler = {
      companyId: 'SAA',
      email: this.addNewTravelerForm.value.email,
      nationality: this.addNewTravelerForm.value.Nationality,
      placeOfResidence: this.addNewTravelerForm.value.residence,
      idNumber: this.addNewTravelerForm.value.identityNumber,
      idType: this.CommonObj.docType,
      dateOfBirth: this._CommonService.formatDateToYMD(
        this.addNewTravelerForm.value.dateOfBirth,
      ),
      title: this.addNewTravelerForm.value.title,
      firstName: this.addNewTravelerForm.value.firstname,
      lastName: this.addNewTravelerForm.value.lastname,
      gender: this.addNewTravelerForm.value.gender,
      employeeCode: this.addNewTravelerForm.value.empCode,
      phoneExtension: this.addNewTravelerForm.value.countryCode,
      mobile: this.addNewTravelerForm.value.mobileNumber,
      branchId: String(this.addNewTravelerForm.value.branch),
      departmentId: this.addNewTravelerForm.value.department
        ? String(this.addNewTravelerForm.value.department)
        : null,
      designationId: this.addNewTravelerForm.value.designation
        ? String(this.addNewTravelerForm.value.designation)
        : null,
      employeeType: this.addNewTravelerForm.value.userType,
      expiryDate: this._CommonService.formatDateToYMD(
        this.addNewTravelerForm.value.docExpiary,
      ),
    };
    const userTypeMap: any = {
      0: 'Admin',
      1: 'Traveller',
      2: 'Employee'
    };

    const userTypeValue = this.addNewTravelerForm.value.userType;
    const mappedUserType = userTypeMap[userTypeValue];
    this._camService
      .insertNewTravelerV1(payload)
      .then((res) => {
        this.travelerManagement.add_traveler_save_click(payload,mappedUserType)
        // this.sendRegistrationEmail(this.addNewTravelerForm.value, mappedUserType);
        if (!res) {
          this._ToastrApiService.show(
            'error',
            'No response received from server.',
          );
          return;
        }

        // Handle API response
        switch (res.status) {
          case 'Success':
            this._ToastrApiService.show(
              'success',
              res.message || 'Traveler Created Successfully.',
            );

            this._Router.navigate(['/cam/traveler-management']);
            break;

          case 'Conflict':
            this._ToastrApiService.show(
              'warning',
              res.message || 'Duplicate entry detected.',
            );
            break;

          default:
            this._ToastrApiService.show(
              'error',
              res.message || 'Unexpected response from server.',
            );
            console.warn('Unhandled status:', res);
            break;
        }
      })
      .catch((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          'Something went wrong while saving the traveler. Please try again later.';

        this._ToastrApiService.show('error', errorMessage);
      })
      .finally(() => {
        this.isInviteLoading = false;
      });
  }

  onCancel() {
    this.travelerManagement.add_traveler_cancel_click();
    this._Router.navigate(['/cam/traveler-management']);
  }

  verifyDomainName() {

    const QlAccessToken: any = localStorage.getItem('QlAccessToken');
    const emailControl = this.addNewTravelerForm.get('email');

    if (!QlAccessToken || !emailControl?.value) return;

    const email: string = emailControl.value;
    const decoded: any = jwtDecode(QlAccessToken);

    console.log(decoded.domainName);
    console.log(decoded.hasDomain);

    if (decoded.hasDomain != 'false') {
      const afterAt = email.split('@')[1]; // part after @


      // 🔥 Compare domain
      if (afterAt.toLowerCase() !== decoded.domainName?.toLowerCase()) {
        // Set custom error
        emailControl.setErrors({
          ...(emailControl.errors || {}),
          domainMismatch: true,
        });
      } else {
        // Remove only domainMismatch error if exists
        if (emailControl.hasError('domainMismatch')) {
          const errors = { ...(emailControl.errors || {}) };
          delete errors['domainMismatch'];
          emailControl.setErrors(Object.keys(errors).length ? errors : null);
        }
      }
    }
  }

  async checkEmailExist(): Promise<void> {

    this.verifyDomainName();
    const emailControl = this.addNewTravelerForm.get('email');
    if (!emailControl || !emailControl.value) return;

    const email = emailControl.value;
    const companyID = 'SAA';
    const payload = { loginID: email };

    try {
      const [verifyRes, matchingRes] = await Promise.all([
        this._camService.checkEmailExist(companyID, email), // API 1
        this._camService.isAvailableLogin(payload), // API 2
      ]);

      // 🔹 RESULT 1 → Verify User Exists API
      const userExists = verifyRes?.data === true; // adjust if API structure differs

      // 🔹 RESULT 2 → Matching Profile API
      const hasMatch = !matchingRes?.data?.isAvailable;

      // 🚨 If ANY API says email exists → show error
      if (hasMatch || userExists) {
        emailControl.setErrors({ ...emailControl.errors, isExist: true });
      } else {
        if (emailControl.hasError('isExist')) {
          const errors = { ...emailControl.errors };
          delete errors['isExist'];
          emailControl.setErrors(Object.keys(errors).length ? errors : null);
        }
      }
    } catch (error: any) {
      console.error('Email verification APIs failed:', error);
      const hasReg019Error = error?.error?.details?.some?.(
        (detail: any) => detail?.code === 'REG-019',
      );
      if (hasReg019Error) {
        const currentErrors = { ...(emailControl.errors || {}) };
        emailControl.setErrors({ ...currentErrors, isExist: true });
      }
    }
  }
  getSiteCoreArray(keyString: string) { 
    const data = this.onBoardContent?.[keyString];
    if (data && Array.isArray(data)) {
      this.titles = data.filter((option: any) => option.Key !== 'miss' && option.Key !== 'mstr');
    } else {
      this.titles = data || [];
    }
  }

  //Admin,employee,travellaranger registered successfully
  async sendRegistrationEmail(formData: any, userType: 'admin' | 'employee' | 'traveller') {
    const configMap: any = {
      admin: {
        nameKey: 'adminName',
        event: 'b2bSuccessfulAdminProfileSetup'
      },
      employee: {
        nameKey: 'employeeName',
        event: 'b2bSuccessfulEmployeeProfileSetup'
      },
      traveller: {
        nameKey: 'employeeName',
        event: 'b2bSuccessfulTravelArrangerProfileSetup'
      }
    };

    const selectedConfig = configMap[userType];

    if (!selectedConfig) {
      console.error('Invalid userType');
      return;
    }
    const ctaUrl = await this.generateTravelerCTAUrl(formData.email);
    const qlAccessToken: any = localStorage.getItem('QlAccessToken');
    const companyLogo: any = localStorage.getItem('companylogo');
    const decoded: any = jwtDecode(qlAccessToken);

    const fullName = `${formData.firstname} ${formData.lastname}`;
    const companyName = decoded.companyName;
    const suportUrl = "https://www.saudia.com/en/Support/HelpAndSupport";
    const payload: any = {
      [selectedConfig.nameKey]: fullName,
      ctaUrl: ctaUrl || '',
      companyName: companyName,
      companyLogo: companyLogo || '',
      supportUrl: suportUrl || ''
    };

    const finalPayload = {
      lang: 'en-SA',
      notificationEvent: selectedConfig.event,
      notificationParameters: payload,
      recipients: {
        to: [
          {
            address: formData.email
          }
        ]
      },
      attachments: []
    };
    console.log("final payload traveller regisration mail", finalPayload);
    this._CamService.sendEmailNotification('email', finalPayload).subscribe({
      next: (res: any) => {
        console.log('Email sent successfully', res);
      },
      error: (err): any => {
        console.log('Email error', err);
        this._DataLayerService.errors_occured(err, this.addNewTravelerForm.value.userType);
      }
    });
  }

  async generateTravelerCTAUrl(email: string): Promise<string | null> {

    try {
      const response = await this._CamService.createTravelerToken(email);

      if (response?.status === 'Created' || response?.status === 'Success') {
        const token = response?.data;

        if (token) {
          const baseUrl = window.location.origin;
          const targetUrl = `${baseUrl}/traveler-signup?token=${encodeURIComponent(token)}`;

          return targetUrl;
        }
      }
    } catch (error: any) {
      console.error("token generate error", error);
    }

    return null;
  }

  updatePhoneNumberValidators() {
    
    const phoneControl = this.addNewTravelerForm.get('mobileNumber');
    const selectedCountry = this.addNewTravelerForm.get('countryCode')?.value;
    const countryCode = selectedCountry;

    // Check if India (ISD code +91 or 91)
    const isIndia = countryCode === '+91' || countryCode === '91';

    if (isIndia) {
      // India: exactly 10 digits
      phoneControl?.setValidators([
        Validators.pattern(/^\d{10}$/),

      ]);
    } else {
      // Other countries: 6 to 12 digits
      phoneControl?.setValidators([
        Validators.minLength(6),
        Validators.maxLength(12)
      ]);
    }

    phoneControl?.updateValueAndValidity();
  }



  private async _checkEmployeeCodeDuplicate(employeeCode: string): Promise<void> {
    this.isEmpCodeCheckLoading = true;
    const empCodeCtrl = this.addNewTravelerForm.get('empCode')!;
    try {
      const res = await this._camService.checkDuplicateEmployeeCode({ employeeCode });
      // HTTP 200 → employee code already exists → not acceptable
      this.isEmpCodeAcceptable = false;
      empCodeCtrl.setErrors({ empCodeExists: res?.message || 'Employee code already exists.' });
      empCodeCtrl.markAsTouched();
    } catch (error: any) {
      // HTTP 404 → not found → available
      this.isEmpCodeAcceptable = error?.status === 404;
    } finally {
      this.isEmpCodeCheckLoading = false;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
